import Image from "next/image";
import UilSpinner from "@/public/assets/loaders/spinner.svg";

const UilCircularLoader = ({ size = 58 }) => {
  return (
    <Image
      src={UilSpinner}
      alt="Loading..."
      width={size}
      height={size}
      className="spinner"
    />
  );
};
export default UilCircularLoader;
